export default "__VITE_ASSET__Cb$GM4xt__"